<template>
    <div>
        <div class="main">
            <div class="dialog-view" v-loading="loading">
                <div class="view-top">
                    <div class="left">
                        提报数据详情
                    </div>
                    <div class="right">
                        <i @click="closeDetail" class="el-icon-close" style="color:#000;cursor: pointer;"></i>
                    </div>
                </div>
                <div class="view-main" v-if="storeslist.length > 0">
                    <div class="main-top">门店情况统计</div>
                    <div class="main-list" >
                        <div class="list-item" v-for="item,index in storeslist" :key="index">
                            <div class="item-left">
                                <div class="left-div">{{ item.displayName }}</div>
                                <!-- <div class="left-div" v-if="item.fieldName=='wineTables'">(包含洋酒、鸡尾酒、特调酒)</div>
                                <div class="left-div" v-if="item.fieldName=='beerTables'">(包含ABI啤酒)</div> -->
                            </div>
                            <div class="item-right">
                                <span v-if="getItemvalue(item.fieldName)">{{getItemvalue(item.fieldName)}}</span>
                                <span v-else></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="view-line" v-if="storeslist.length > 0"></div>
                <div class="view-main" v-if="singleStorelist.length > 0">
                    <div class="main-top">单店执行情况</div>
                    <div class="main-list">
                        <div class="list-item" v-for="item,index in singleStoresplicelist" :index="index">
                            <div class="item-left">
                                <div class="left-div">{{ item.displayName }}</div>
                            </div>
                            <div class="item-right">
                                <span v-if="getItemvalue(item.fieldName)">{{getItemvalue(item.fieldName)}}</span>
                                <span v-else></span>
                            </div>
                        </div>
                        <!-- <div class="list-item">
                            <div class="item-left">
                                <div class="left-div">活动日日均提升率</div>
                            </div>
                            <div class="item-right">{{getPercentage('活动日均提升率')}}</div>
                        </div>
                        <div class="list-item">
                            <div class="item-left">
                                <div class="left-div">上座率</div>
                            </div>
                            <div class="item-right">{{getPercentage('上座率')}}</div>
                        </div>
                        <div class="list-item">
                            <div class="item-left">
                                <div class="left-div">触达率</div>
                            </div>
                            <div class="item-right">{{getPercentage('触达率')}}</div>
                        </div> -->
                    </div>
                    <div class="main-table" v-if="getItemcheck('skuInfo') && reportDetail.skuInfoList !== null" >
                        <div class="table-title">商品明细</div>
                        <div class="table-main">
                            <el-table
                                :data="reportDetail.skuInfoList"
                                show-header
                                border
                                style="width: 100%">
                                <el-table-column
                                prop="typeName"
                                label="商品类型"
                                align="center"
                                width="200"
                                show-overflow-tooltip
                                >
                                </el-table-column>
                                <el-table-column
                                prop="name"
                                label="名称"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                label="价格"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span>{{formatPrice(scope.row.price)}}</span>
                                </template>
                                </el-table-column>
                                <el-table-column
                                label="数量"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span>{{formatPrice(scope.row.qty)}}</span>
                                </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="main-table" v-if="getItemcheck('ppgInfo') && reportDetail.ppgInfoList !== null" >
                        <div class="table-title">PPG明细</div>
                        <div class="table-main">
                            <el-table
                                :data="reportDetail.ppgInfoList"
                                show-header
                                border
                                style="width: 100%">
                                <el-table-column
                                prop="name"
                                label="名称"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                label="数量"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span>{{formatPrice(scope.row.qty)}}</span>
                                </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="main-table" v-if="getItemcheck('rivalInfo') && reportDetail.rivalInfoList !== null">
                        <div class="table-title">竞品明细</div>
                        <div class="table-main">
                            <el-table
                                :data="reportDetail.rivalInfoList"
                                show-header
                                border
                                style="width: 100%">
                                <el-table-column
                                prop="name"
                                label="名称"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                label="价格"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span>{{formatPrice(scope.row.price)}}</span>
                                </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
                <el-empty description="暂无提报数据" v-if="storeslist.length == 0 && singleStorelist.length == 0"></el-empty>
                <div class="view-btn">
                    <div class="btn" @click="closeDetail">返回</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import gameplanApi from '../../../api/gameplan';
    export default {
      name: 'report-config-pop',
      props: {
        themeDetail:{type:Object, default:{} },
        params:{type:Object, default:{} },
      },
      components: {
      },
      data () {
        return { 
            reportDetail:{},//提报数据详情
            execDataConfigList:[],
            storeslist:[], // 门店情况统计
            singleStorelist:[], //单店执行情况
            singleStoresplicelist:[], //单店执行情况 删除表格相关信息
            loading:true
        }
      },
      computed: {
      },
      watch: {},
      created () {
        this.init()
      },
      mounted () {},
      updated () {
      },
      methods: {
        init () {
            this.getExecDataConfig()
        },
        // 金额千分
        formatPrice(price) {
            return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        // 查询动态业务数据字段
         async getExecDataConfig() {
            let params = {
                themeId: this.themeDetail.themeId
            }
            this.loading = true
            let data = await gameplanApi.getExecDataConfig(params);
            if (data.data.resultCode == "0") {
                this.execDataConfigList = data.data.resultData.execDataConfigList || []
                let storeslist = []
                let singleStorelist = []
                for (let item of this.execDataConfigList) {
                    if (item.fieldGroupName == "门店情况统计" && item.checked == true ) {
                        storeslist.push(item)
                    }
                    if (item.fieldGroupName == "单店执行情况" && item.checked == true ) {
                        singleStorelist.push(item)
                    }
                }
                let singleStoresplicelist = []
                for (let item of singleStorelist) {
                    // console.log(item.fieldGroupName,item.displayName,item,'item');
                    if (item.fieldName !== "skuInfo" && item.fieldName !==  "rivalInfo" && item.fieldName !==  "ppgInfo" ) {
                        singleStoresplicelist.push(item)
                    }
                }
                this.storeslist = storeslist
                this.singleStorelist = singleStorelist
                this.singleStoresplicelist = singleStoresplicelist
                // console.log(storeslist,'storeslist');
                // console.log(singleStorelist,'singleStorelist');
                // console.log(singleStoresplicelist,'singleStoresplicelist');
                this.getReportdetail()
            }
        },
        // 获取提报信息
         async getReportdetail() {
            let params = this.params
            let data = await gameplanApi.getReportdetail(params);
            if (data.data.resultCode == "0") {
                this.reportDetail = data.data.resultData.gpThemeExecDataDTO
                this.loading = false
            } else {
                this.loading = false
            }
        },
        getItemvalue (name) {
            for (let item in this.reportDetail) {
                if (item == name) {
                    // console.log(item,this.reportDetail[item]);
                    if (name =='sprWriteOffAmount') {
                        // return this.reportDetail[item]*1000
                        if (this.reportDetail[item]) {
                            return this.formatPrice(this.reportDetail[item])  +'元'
                        } else {
                            return false
                        }
                    } else {
                        if (this.reportDetail[item]) {
                            return this.formatPrice(this.reportDetail[item])
                        } else {
                            return false
                        }
                    }
                }
            }
        },
        // 判断当前业务是否存在
        getItemcheck (name) {
            let checked = false
            for (let item of  this.execDataConfigList) {
                if (item.fieldName == name) {
                    // console.log(item.fieldName,item.displayName,'name:',name,'checked:', item.checked);
                    checked = item.checked
                }
            }
            // console.log(checked,'checked',name);
            return checked
        },
        // 获取百分比
        getPercentage (size){
            let data = this.reportDetail
            if (size == '活动日均提升率') {
                let num =(((data.activitySalesQty - data.normalSalesQty) / data.normalSalesQty) *100).toFixed(2) + "%"
                // console.log(num,'num-活动日均提升率');
                return num
            } else if (size == '上座率') {
                let num =((data.useTables / data.totalTables) *100).toFixed(2) + "%"
                // console.log(num,'num-上座率');
                return num
            } else if (size == '触达率') {
                let num =((data.touchTables / data.useTables) *100).toFixed(2) + "%"
                // console.log(num,'num-触达率');
                return num
            } else {
                return
            }

        },
        closeDetail () {
            this.$emit('closeChangepop')
        },
    }
}
</script>
<style lang="scss" scoped>
.main {
    // z-index: 5;
    .dialog-view {
        position: fixed;
        border-radius: 8px;
        width: 80%;
        top: 5%;
        left: 10%;
        min-height: 300px;
        max-height: 80vh;
        padding: 20px 27px 20px 27px;
        background-color: #FFFFFF;
        color: #101010;
        z-index: 3;
        overflow: hidden;
        overflow-y: scroll;
        .view-top {
            height: 32px;
            line-height: 32px;
            display: flex;
            margin-bottom: 15px;
            .left {
                font-size: 22px;
                font-weight: 600;
                flex: 1;
            }
            .right {
                width: 32px;
                height: 32px;
                font-size: 32px;
                color: #999191;
            }
        }
        .view-main {
            font-size: 18px;
            color: #1D1D1D;
            .main-top {
                height: 26px;
                line-height: 26px;
                color: #868383;
                font-weight: 600;
                padding-left: 30px;
                margin-bottom: 10px;
            }
            .main-list {
                font-size: 18px;
                display: flex;
                flex-wrap: wrap;
                .list-item {
                    width: 50%;
                    display: flex;
                    text-align: left;
                    padding: 7px 0px;
                    .item-left {
                        padding-left: 70px;
                        width: 65%;
                        .left-div {
                            line-height: 23px;
                        }
                    }
                    .item-right {
                        flex: 1;
                        line-height: 23px;
                        text-align: left;
                    }
                }
            }
        }
        .view-line {
            height: 1px;
            background-color: #868383;
            width: 95%;
            margin: 20px auto;
        }
        .main-table {
            padding-left: 70px;
            .table-title {
                height: 26px;
                line-height: 26px;
                color: #868383;
                font-weight: 600;
                margin: 20px 0px;
            }
            .table-main {
                ::v-deep .el-table th.el-table__cell {
                    color: #101010;
                    background-color: rgba(232, 232, 232);
                }
                ::v-deep .el-table__body tr.current-row>td.el-table__cell {
                    background-color: #FFFFFF !important;
                }
                ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
                    background-color: #FFFFFF !important;
                }
            }
        }
        .view-btn {
            margin: 30px 0px 10px 0px;
            height: 30px;
            line-height: 30px;
            .btn {
                margin: auto;
                width: 80px;
                text-align: center;
                background-color: #FFFFFF;
                color: #cd1231;
                border-radius: 5px;
                border: 1px solid #cd1231;
                cursor: pointer;
            }
        }
    }
}
</style>
